import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import {
  DATE_OPERATORS,
  OPERATORS_FILTERS
} from "@/shared/constants/GeneralConstants";

export const AVAILABILITY_CONSTANTS = {
  URL_ROUTE: "/availability",
  TEXTS: {
    TITLE: "Disponibilidades",
    TITLE_SAVE: "Guardar disponibilidad",
    TITLE_UPDATE: "Actualizar disponibilidad",
    CREATE_BUTTON: "Crear disponibilidad",
    UPLOAD_BUTTON: "Subir agenda",
    TITLE_UPDATE_EVENT: "Gestionar fracción de disponibilidad",
    TITLE_DELETE_EVENT: "Confirmar eliminación",
    TEXT_DELETE_EVENT:
      "¿Está seguro que desea eliminar la fracción de disponibilidad?, Esta acción es irreversible",
    LOCK_EVENT: "BLOQUEAR FRACCIÓN",
    UNLOCK_EVENT: "DESBLOQUEAR FRACCIÓN",
    DELETE_EVENT: "ELIMINAR FRACCIÓN",
    TODAY: "Hoy",
    DAY: "day",
    GREATER_ZERO: "Debe ser mayor que 0",
    REQUIRE_LENGTH: "Debe seleccionar un elemento",
    INVALID_UNTIL_DATE:
      "Fecha hasta debe ser posterior a fecha de la disponibilidad",
    INVALID_DATE:
      "Fecha de disponibilidad inválida: Debe ser igual o posterior a la fecha actual",
    INVALID_TIME: "La hora de inicio debe ser menor a la hora de fin",
    CANNOT_DIVIDE_EVENTS:
      "Se debe definir una duración para crear eventos de igual longitud",
    AVAILABLE: "Disponible",
    LOCKED: "Bloqueado",
    LOAD_MORE_OPTIONS: "Cargar más opciones",
    ID_LISTS: ["name", "status", "space", "responsable", "campus"],
    ITEMS_OF_SELECT: ["Disponible", "No Disponible", "Reservado", "Bloqueado"],
    REBOOT_OPTION_VALUE: "Opciones",
    ITEMS_SELECT_LIST: ["Detalles", "Eventos"],
    EDIT_AVAILABILITY: "Editar Disponibilidad",
    VIEW_AVAILABILITY: "Ver Disponibilidad",
    EDIT_EVENT: "Editar fracción",
    SHOW_EVENTS: "Ver eventos",
    INFO: "Info",
    MINUTES: "min",
    SHOULD_CHOSE_SERVICE_FIRST:
      "Recuerde que para editar el nombre debe escoger primero el servicio",
    SELECT_SERVICES: "Seleccione servicio(s)",
    LIST_LOADING: "Cargando lista...",
    AVAILABILITY_SERVICES: "Servicios de la disponibilidad",
    REDIRECT_TO_PATIENT_PROFILE:
      "Será redirigido al perfil del paciente. Desea continuar?",
    MUST_BE_SELECTED_MANAGER: "Debe seleccionar al menos un responsable",
    SPACES_RESERVED: "espacios reservados"
  },
  CONFIGURATIONS: {
    VIEW_TYPES: [
      { label: "Mes", value: "month" },
      { label: "Semana", value: "week" },
      { label: "Día", value: "day" },
      { label: "4 días", value: "4day" }
    ],
    LOCALE: "es-co",
    OVERLAP_MODE: "column",
    ALLOWED_MINUTES: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
    MORE_TEXT: "{0} eventos",
    FIRST_INTERVAL_VIEW: 6,
    COLOR_OPACITY: "99",
    SPACES_RESERVED: "espacios reservados"
  },
  LABEL: {
    NAME: "Nombre *",
    DATE: "Fecha *",
    START_TIME: "Hora inicio *",
    END_TIME: "Hora final *",
    STATE: "Estado *",
    DURATION: "Duración (Min) *",
    SERVICE: "Servicio *",
    CAMPUS: "Sede *",
    SPACE: "Espacio físico *",
    CAPACITY: "Capacidad *",
    DEPENDENCY: "Dependencia *",
    MANAGER: "Responsables *",
    RECURRENT: "Evento recurrente",
    WEEKDAY: "Días de la semana",
    UNTIL_DATE: "Hasta el",
    HOLIDAYS: "Incluir festivos",
    OPTIONS: "Opciones"
  },
  WEEK_DAYS: [
    { value: 0, text: "Domingo" },
    { value: 1, text: "Lunes" },
    { value: 2, text: "Martes" },
    { value: 3, text: "Miércoles" },
    { value: 4, text: "Jueves" },
    { value: 5, text: "Viernes" },
    { value: 6, text: "Sábado" }
  ],
  STATES: ["Disponible", "Bloqueado"],
  VALIDATORS: {
    GREATER_ZERO: (v: number) =>
      v > 0 || AVAILABILITY_CONSTANTS.TEXTS.GREATER_ZERO,
    REQUIRE_LENGTH: (v: []) =>
      v.length > 0 || AVAILABILITY_CONSTANTS.TEXTS.REQUIRE_LENGTH,
    EMPTY_SPACE: (v: string) =>
      (v && v.trim().length > 0) || "El nombre no puede estar vacío"
  },
  SPLITTERS: {
    MONTH: "- ",
    TIME: ":00 GMT"
  },
  COLORS: {
    GREEN: "green",
    GREY: "grey",
    PURPLE: "purple",
    CANCELED: "#9E9E9E",
    RESERVED: "#277099",
    AVAILABLE: "#2770E8",
    LOCKED: "#9E9E9E"
  },
  EVENTS: {
    SAVE_MODAL_ACCEPT: "saveModalAccept",
    SAVE_MODAL_CANCEL: "saveModalCancel",
    UPDATE_MODAL: "updateModal",
    CREATE_MODAL: "createModal",
    EDIT_MODAL_ACCEPT: "editModalAccept",
    EDIT_MODAL_CANCEL: "editModalCancel"
  },
  FILTERS: {
    SERVICE: {
      name: "Servicio",
      value: "",
      id: "service",
      active: false
    }
  },
  SELECT_TAKEN_OPTION: {
    DETAILS: {
      TITLE: "Detalles"
    },
    EVENTS: {
      TITLE: "Eventos"
    }
  },
  DETAIL_LABELS: {
    DOCUMENT: "Documento",
    CAMPUS: "Sede",
    ADDRESS: "Dirección",
    PHONE: "Teléfono",
    STATUS: "Estado",
    SPACE: "Espacio",
    CAPACITY: "Capacidad",
    ASIGNED_TO: "Asignado a",
    ASIGNED_BY: "Asignado por",
    DATE_HOUR: "Fecha y hora",
    DURATION: "Duración",
    PATIENTS: "Pacientes",
    SUGGESTIONS: "Observaciones",
    SERVICE_NAME: "Servicio"
  },
  EVENT_LABELS: ["Duración", "Estado", "Hora"],
  USER_DEFAULT_ROUTE: "profile/aVSTzBKiO6J64Kw88s3V",
  SEARCH_FILTER_AVAILABILITY: {
    EMPTY_SPACE: {
      name: "Espacio",
      value: "",
      id: "space",
      active: false
    },
    EMPTY_RESPONSABLE: {
      name: "Responsable",
      value: "",
      id: "responsable",
      active: false
    },
    EMPTY_CAMPUS: {
      name: "Sede",
      value: "",
      id: "campus",
      active: false
    }
  },
  DIALOG_MESSAGE: {
    ERROR_ID_NOT_FOUND: "La disponibilidad a eliminar no existe",
    NOT_USERS_FOR_DEPENDENCY: "No hay usuarios para la dependencia seleccionada"
  },
  DELETE_REASON_MODAL: {
    TITLE: "Eliminar Disponibilidad",
    MESSAGE: "Ingrese la razón por la cual va a eliminar la disponibilidad: "
  },
  EDIT_MODE: "edit",
  DELETE_MODE: "delete",
  OPTION_MODAL: {
    OPTION_LIST: [
      { name: "Esta disponibilidad", value: "individual" },
      {
        name: "Esta disponibilidad y las posteriores",
        value: "deAquiEnAdelante"
      },
      { name: "Todas las disponibilidades", value: "todos" }
    ],
    TITLE_EDIT: "Actualizar disponibilidad",
    TEXT_EDIT: "Seleccione una opción",
    TITLE_DELETE: "Eliminar disponibilidad",
    TEXT_DELETE: "Seleccione una opción"
  },
  VALIDATE_KEYS: {
    UNTIL: "until",
    WEEKDAYS: "weekdays",
    RESPONSABLE: "responsable",
    SERVICES: "serviceTemplate"
  },
  MONTHS_UNTIL_OCTOBER: 10,
  SNACKBAR: {
    NO_CHOSEN_FILTERS: "No hay filtros seleccionados, por favor agregue uno",
    NO_AVAILABILITY_CREATION_DUE_MULTIFILTERS:
      "No se puede crear disponibilidad teniendo filtros con multiples opciones",
    AT_LEAST_ONE_FILTER_TO_CREATE:
      "Debe al menos seleccionar un filtro para crear una disponibilidad"
  },
  STYLES: {
    STATUS_CHIP_RESERVED: "status-chip-reserved",
    STATUS_CHIP_AVAILABLE: "status-chip-available",
    STATUS_CHIP_BLOCKED: "status-chip-blocked"
  }
};

export const AVAILABILITY_STATES = {
  AVAILABLE: "Disponible",
  NOT_AVAILABLE: "No disponible",
  RESERVED: "Reservado",
  BLOQUED: "Bloqueado",
  DELETED: "Eliminado"
};

export const EVENTS_STATES = {
  AVAILABLE: "Disponible",
  NOT_AVAILABLE: "No disponible",
  RESERVED: "Reservado",
  BLOQUED: "Bloqueado"
};

export const AVAILABILITY_STATES_ARRAY = [
  { key: AVAILABILITY_STATES.AVAILABLE, name: AVAILABILITY_STATES.AVAILABLE },
  { key: AVAILABILITY_STATES.BLOQUED, name: AVAILABILITY_STATES.BLOQUED }
];

export const AVAILABILITY_FILTERS_NAME = {
  NAME: "name",
  SERVICE: "service",
  STATUS: "status",
  RESPONSABLE: "responsable",
  CAMPUS: "campus",
  SPACE: "space"
};

export const FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "availability",
    mainFilterName: "Disponibilidad",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para las disponibilidades",
    secondaryFilters: [
      {
        name: "Nombre",
        key: AVAILABILITY_FILTERS_NAME.NAME,
        type: "secondaryFilter",
        display: "list",
        default: true,
        operators: OPERATORS_FILTERS,
        avatar: "mdi-plus-circle-outline",
        multipleOff: true,
        disabled: false,
        canEdit: true,
        loadingData: false
      },
      {
        name: "Servicio",
        key: AVAILABILITY_FILTERS_NAME.SERVICE,
        type: "secondaryFilter",
        display: "list",
        operators: OPERATORS_FILTERS,
        avatar: "mdi-form-select",
        disabled: false
      },
      {
        name: "Estado",
        key: AVAILABILITY_FILTERS_NAME.STATUS,
        type: "secondaryFilter",
        display: "list",
        options: AVAILABILITY_STATES_ARRAY,
        avatar: "mdi-state-machine",
        operators: OPERATORS_FILTERS
      },
      {
        name: "Sede",
        key: AVAILABILITY_FILTERS_NAME.CAMPUS,
        type: "secondaryFilter",
        display: "list",
        operators: OPERATORS_FILTERS,
        avatar: "mdi-hospital-building",
        disabled: false
      },
      {
        name: "Espacio físico",
        key: AVAILABILITY_FILTERS_NAME.SPACE,
        type: "secondaryFilter",
        display: "list",
        operators: OPERATORS_FILTERS,
        avatar: "mdi-home",
        disabled: false
      },
      {
        name: "Responsable",
        key: AVAILABILITY_FILTERS_NAME.RESPONSABLE,
        type: "secondaryFilter",
        display: "list",
        avatar: "mdi-account-supervisor",
        operators: OPERATORS_FILTERS,
        disabled: false
      },
      {
        name: "Fecha",
        key: "dateCreated",
        avatar: "mdi-calendar-month",
        type: "secondaryFilter",
        disabled: true,
        operators: DATE_OPERATORS,
        display: "picker"
      }
    ]
  }
];
export const CONTEXT_PANEL_FILTERS_LIST: Filter[] = [
  {
    mainFilterKey: "availability",
    mainFilterName: "Disponibilidad",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para las disponibilidades",
    secondaryFilters: [
      {
        name: "Nombre",
        key: AVAILABILITY_FILTERS_NAME.NAME,
        type: "secondaryFilter",
        display: FILTER_DISPLAY.UNIQUE,
        default: true,
        operators: OPERATORS_FILTERS,
        avatar: "mdi-form-textbox",
        disabled: false
      },
      {
        name: "Servicio",
        key: AVAILABILITY_FILTERS_NAME.SERVICE,
        type: "secondaryFilter",
        display: "list",
        options: [],
        operators: OPERATORS_FILTERS,
        avatar: "mdi-form-select"
      }
    ]
  }
];

export const MINUS_FIVE_HOURS = 5 * 60 * 60 * 1000;

export const UPDATING_TITLE = "Actualizar";

export const DEFAULT_TIME = "00:00";

export const DEFAULT_SCROLL_TO_TIME = "05:00";

export const AVAILIABILITY_ACCESS = {
  GET: "consultar disponibilidades",
  POST: "crear disponibilidades",
  PUT: "modificar disponibilidades",
  DELETE: "eliminar disponibilidades"
};
